import { addSideEffects, initAction } from '@poa/state';
import moment from 'moment';
import { normalizeDateForBackend } from '../../utils/dates';
import { clone } from '../shared/clone';
import {
  changeColumnPreset,
  deletePreset,
  fetchStats,
  fetchEmptyStats,
  saveColumnPreset,
  setDates
} from './statistics.actions';

const statisticsAvailablePresets = 'financesAvailablePresets-v2';
const statisticsLastSelectedPreset = 'financesLastSelectedPreset-v2';


addSideEffects(fetchStats, async (payload, { actions, store, env }) => {
  try {
    const { startDate, endDate } = store.statistics.filters;
    const finances = await env.api.statistics.fetchStats(
      normalizeDateForBackend(startDate),
      normalizeDateForBackend(endDate)
    );
    finances.loaded ? actions.statisticsActions.fetchStatsWaiting(finances.loaded) : actions.statisticsActions.fetchSuccess(finances.data);
  } catch (e) {
    console.error(e);
    actions.statisticsActions.fetchFailed();
    throw e;
  }
});


addSideEffects(fetchEmptyStats, async (_, { actions, store, env }) => {
  try {
    // fetch empty stats
    const { startDate, endDate, search } = store.statistics.filters;

    if (search) {
      const finances = await env.api.statistics.fetchStats(
        normalizeDateForBackend(startDate),
        normalizeDateForBackend(endDate)
      );
      finances.loaded ? actions.statisticsActions.fetchStatsWaiting(finances.loaded) : actions.statisticsActions.fetchSuccess(finances.data);
    } else {

      const finances = await env.api.statistics.fetchEmptyStats();
      actions.statisticsActions.fetchSuccess(finances.data);
    }
  } catch (e) {
    console.error(e);
    actions.statisticsActions.fetchFailed();
    throw e;
  }
});


addSideEffects(setDates, async ({ startDate, endDate, shouldFetch }, { actions, env }) => {
  if (!shouldFetch) {
    return;
  }
  await env.storage.setItem('statistics-dates', clone({ startDate, endDate }));

  // try {
  //   const finances = await env.api.statistics.fetch(startDate, endDate);
  //   actions.statisticsActions.fetchSuccess(finances);
  // } catch (e) {
  //   console.error(e);
  //   actions.statisticsActions.fetchFailed();
  //   throw e;
  // }
});

// persist settings
addSideEffects(saveColumnPreset, async (_, { env, actions, store }) => {
  const { availablePresets, currentPresetId } = store.statistics.filters.columnSettings;

  await env.storage.setItem(statisticsAvailablePresets, clone(availablePresets));
  await env.storage.setItem(statisticsLastSelectedPreset, currentPresetId);
});

addSideEffects(deletePreset, async (_, { env, actions, store }) => {
  const { availablePresets, currentPresetId } = store.statistics.filters.columnSettings;

  await env.storage.setItem(statisticsAvailablePresets, clone(availablePresets));
  await env.storage.setItem(statisticsLastSelectedPreset, currentPresetId);
});

addSideEffects(changeColumnPreset, async ({ preset }, { env, actions, store }) => {
  const { currentPresetId } = store.statistics.filters.columnSettings;

  await env.storage.setItem(statisticsLastSelectedPreset, currentPresetId);
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const availablePresets = await env.storage.getItem(statisticsAvailablePresets);
  const presetId = await env.storage.getItem(statisticsLastSelectedPreset);
  const dates = await env.storage.getItem('statistics-dates');

  if (dates) {
    actions.statisticsActions.setDates({
      startDate: dates.startDate ? moment(dates.startDate) : null,
      endDate: dates.endDate ? moment(dates.endDate) : null,
      shouldFetch: false
    });
    return;
  }

  if (availablePresets && presetId) {
    actions.statisticsActions.resetColumnSettings({ presetId, availablePresets });
    return;
  }

  if (availablePresets) {
    actions.statisticsActions.resetColumnSettings({
      presetId: availablePresets[0].id, // default one
      availablePresets
    });
    return;
  }

  actions.statisticsActions.resetColumnSettings({
    presetId: store.statistics.filters.columnSettings.availablePresets[0].id, // default one
    availablePresets: store.statistics.filters.columnSettings.availablePresets
  });
});
